import { Box, styled } from "@mui/material";

export const StyledExpos = styled(Box)(({ theme }) => ({
  ".header": {
    height: "20rem",
    background: theme.color.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    h1: {
      color: theme.color.background,
    },
  },
  ".expoWrapper": {
    width: "70%",
    display: "flex",
    flexDirection: "column",
    paddingBlock: "2rem",
    margin: "auto",
    gap: "1rem",
    ".newExpoHeader": {
      display: "flex",
      justifyContent: "space-between",
      svg: {
        cursor: "pointer",
      },
    },
    ".newExpo": {
      width: "100%",
      background: theme.color.background,
      boxShadow: `0px 0px 3px 3px ${theme.contrast.lighter}`,
      borderRadius: "10px",
      padding: "2rem",
      boxSizing: "border-box",
      svg: {
        color: theme.color.contrastColor,
      },
      ".wrapper": {
        display: "flex",
        gap: "3rem",
        alignItems: "center",
        ".imageWrapper": {
          width: "40rem",
          img: {
            width: "100%",
            height: "100%",
            objectFit: "contain",
          },
        },
        ".info": {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          width: "100%",
          height: "70%",
          gap: "1rem",
          h2: {
            color: theme.color.contrastColor,
          },
          ".infoItem": {
            display: "flex",
            alignItems: "center",
            gap: "2rem",
            maxWidth: "80%",
            svg: {
              minWidth: "2rem",
            },
          },
        },
      },
    },
    "svg:hover": {
      color: theme.color.dark,
    },
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.tablet}px)`]: {
    ".header": {
      height: "25vh",
    },
    ".expoWrapper": {
      width: "90%",
      paddingBlock: "1rem",
      ".newExpoHeader": {
        textAlign: "center",
        paddingBottom: "1rem",
      },
      ".newExpo": {
        display: "flex",
        flexDirection: "column",
        ".wrapper": {
          display: "flex",
          flexDirection: "column",
          ".imageWrapper": {
            width: "20rem",
          },
          ".info": {
            ".infoItem": {
              maxWidth: "100%",
            },
          },
        },
      },
    },
  },
}));
